var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlocks = function SvgBlocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 8,
    y: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    y: 8,
    rx: 1
  }))));
};
export default SvgBlocks;